import { Accordion, AccordionItem } from "@heroui/react";
import { useRef } from "react";

import { FAQS } from "~/data/faqs";
import { track } from "~/utils/analytics";

export const FAQ = () => {
  // Capture once per question per page-view (multiple expands wouldn't
  // give us new signal and would just inflate event volume).
  const seen = useRef<Set<string>>(new Set());

  return (
    <section className="mt-14">
      <h2 className="font-bangers text-2xl text-center">FAQ</h2>
      <div className="mt-4">
        <Accordion
          variant="splitted"
          selectionMode="multiple"
          isCompact
          onSelectionChange={(keys) => {
            const set = new Set(Array.from(keys as Set<string>));
            for (const id of set) {
              if (!seen.current.has(id)) {
                seen.current.add(id);
                track("faq_expanded", { question_id: id });
              }
            }
          }}
          itemClasses={{
            base: "bg-neutral-900/60 border-1 border-neutral-800 shadow-none mb-2 rounded-xl",
            title: "font-bangers text-base",
            content: "font-mono text-sm opacity-80 pb-4 leading-snug",
            trigger: "py-3",
          }}
        >
          {FAQS.map((faq) => (
            <AccordionItem key={faq.id} aria-label={faq.q} title={faq.q}>
              {faq.a}
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
